
















































































































































































































































































































































































































































































































































































import Fragment from "../../Fragment.vue";
import ApiPaginator from "./ApiPaginator.vue";
import ApiSearchKendoGrid from "./ApiSearchKendoGrid.vue";
import IconButton from "../../IconButton.vue";
import Tooltip from "../../Tooltip.vue";

import Vue, { PropType } from "vue";
import ApiSearch, { ApiSearchColumn } from "../models/ApiSearch";
import { getAltRow, getHeaderClasses, getFieldClasses } from "@/utils/classes";
import { PaginatedPager } from "@/models/Pager";
import { FilteringModel, SortingModel, SortOrder } from "@/services/filtering";

import ServerSideSearchApi from "../services/ServerSideSearchApi";
import { getApiSearchState, saveApiSearchState } from "../services/ApiSearchStateStore";
import { debounce } from "debounce";
import eventBus from "@/services/eventBus";
import AllCheckUncheck from "@/components/AllCheckUncheck.vue";
import DateInput from "@/components/DateInput.vue";
import { groupBy } from "@/utils/array";

interface Data {
  /** Local API instance */
  api: ServerSideSearchApi;
  /** CurrentPage, PageSize, SearchText, Filter, Sorting container */
  apiSearch: ApiSearch;
  /** Displayed items */
  items: object[];
  /** Total item count */
  totalItems: number;
  /** Displayed columns mapped as "ApiSearchColumn" */
  localColumns: ApiSearchColumn[];
  /** Dispaly in Table (or List) view - @default true */
  isTableView: boolean;
  /** Display filters - @default false */
  isFilterVisible: boolean;

  loading: boolean;
  /** Következő oldal betöltése folyamatban (infinite scroll) */
  loadingMore: boolean;
  eventListenersAdded: boolean;
  hasFiltering: boolean;
  hasSorting: boolean;
  multiSelectSelectedOptions: any;
}

interface Methods {
  showItem(item: any): boolean;
  refreshClick(): void;
  resetFilterClick(): void;
  resetSortClick(): void;

  /** Load items */
  changeHandler(): Promise<void>;
  pagerChanged(pager: PaginatedPager): void;
  /** Load and append the next page (infinite scroll) */
  loadNextPage(): Promise<void>;
  attachInfiniteScroll(): void;
  reobserveInfiniteScroll(): void;

  getFieldOrder(field: string): SortOrder;
  toggleSort(field: string): void;

  getHeaderClasses(column: ApiSearchColumn): string;
  getFieldClasses(column: ApiSearchColumn): string;
  getAltRow(i: number): string;
  getRowStyle(item: any): object;
  closeItemDetails(item: any, event?: Event): void;
  toggleExtraFilterVisibility(): void;
  addFilterWIdthEventListeners(): void;
  multiSelectSelectionChanged(): void;
  applyApiSearchValues(source: ApiSearch | undefined): void;
}

interface Computed {
  hasCustomTable: boolean;
  hasCustomTableBody: boolean;
  hasDetails: boolean;
  hasListView: boolean;
  hasFilters: boolean;
  hasViews: boolean;
  hasNoItems: boolean;
  hasHeaders: boolean;
  hasComponentNextToCreateButton: boolean;
  hasBottom: boolean;
  hasGrouping: boolean;
  grouppedRows: any[];
  effectiveColor: string;
  effectiveColorCss: string;
  useKendoGrid: boolean;
  rootCssVars: object;
  persistKey: string;
}

interface Props {
  /** Page title */
  title: string;

  //! Search API
  /** API path */
  url: string;
  /** Selectable page sizes - @default [10,20,50,100] */
  baseSizes: number[];
  /** Debounce delay - @default 0 */
  delay: number;

  hideOnEmpty: boolean;

  openDetailsByDefault: boolean;

  //! Top Buttons
  /** Display "Create" button with the given title */
  create: string;
  /** Display "Remove Filter" button - @default true */
  resetFilter: boolean;
  /** Display "Remove Sort" button - @default true */
  resetSort: boolean;
  /** Display "Search Box" - @default true */
  search: boolean;
  /** Displayed Placeholder inside the Search Box @default "Keresés" */
  searchPlaceholder: string;
  /** Tooltip of the Search Box magnifier icon @default "" (no tooltip) */
  searchTooltip: string;
  /** Display "Filter" button - @default false
   * @todo passed props
   * @todo default view */
  showFilter: boolean;
  /** Display "List/Table view" buttons - @default false
   * @todo passed props
   * @todo default view */
  multiView: boolean;
  /** Display "Refresh" button - @default true */
  refresh: boolean;
  /** Display divider - @default true */
  showDivider: boolean;
  /** Display extra date picker - @default false */
  showExtraDateFilter: boolean;
  /** Table column padding - @default 16 */
  tableColPadding: number;

  //! Table
  /** Raw columns - @default [] */
  columns: ApiSearchColumn[];
  /** List should be filterable - @default true */
  filterable: boolean;
  /** List should be sortable - @default true */
  sortable: boolean;
  /** Same width for every col - @default false */
  fixedTable: boolean;
  /** Maximum column width for every col - @default 200 */
  maxColWidth: number;
  /** Replace "details" prop name - @default "details" */
  detailsField: string;
  /** Display the whole content on hover - @default false */
  displayTitles: boolean;
  hasPager: boolean;
  exclusiveItems: number[];
  /** Extra filters passed through as a prop */
  extraFilter: FilteringModel | undefined;
  multiselect: boolean;
  /** Open all details */
  openDetails: boolean;
  /** Set alternative backgorund to tr and th elements */
  altBackground: boolean;
  /** It doesn't load autamaticaly when page open or searchText is changed */
  autoLoad: boolean;
  /** Extra object passed through as a prop */
  apiSearchExtraFilter: any;
  //refresh event
  refreshEvent: string;
  /** For setting the unique eventbus name **/
  name: string;
  /** Filter field grows with text input */
  filterFieldAutoGrow: boolean;
  /** Insert details as it is, instead of wrapping in a tr-td */
  detailsRaw: boolean;
  /** Display a close (chevron-up) button at the bottom of the details row - @default false */
  detailsCloseButton: boolean;
  /** Progress icon overlay instead of removing rows and displaying the progress icon */
  overlayProgressIcon: boolean;

  /** Groupping column */
  groupColumn: string | null;
  searchTextOnEnter: boolean;
  autoHideFilterSortButtons: boolean;
  /** Kijelölt (item[selectedField] === true) sorok háttérszíne */
  selectedRowColor: string;
  /** Melyik mező jelöli a sor "kijelölt" állapotát (default: "selected") */
  selectedField: string;
  /** A komponens fő színe */
  color: string;
  /** Végtelen görgetés: lapozó helyett a lista aljára görgetve töltődik be
   * a következő oldal (hozzáfűzéssel) - @default false */
  infiniteScroll: boolean;
  /** A szűrők/keresés/rendezés túlélik a route-váltást (name+url kulccsal) - @default false */
  persistFilters: boolean;
  /** Kendo grid a v-simple-table helyett (átrendezhető, átméretezhető oszlopok) - @default false; a layoutKey megadása is bekapcsolja */
  kendoGrid: boolean;
  /**
   * Az elrendezés-profilok kulcsa (rmgenuser_setting.control_name, max 30 kar.), oldalanként egyedi; megadva Kendo grid + jobb klikk profil-menü.
   * Konvenció: UPPER_SNAKE_CASE, `<OLDAL>[_<VÁLTOZAT>]` (pl. `GENERAL_INCOMING_INVOICES`, `PARTNERS`). Kiadás után ne változzon, mert a mentett profilok elvesznek.
   */
  layoutKey: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Fragment,
    ApiPaginator,
    ApiSearchKendoGrid,
    IconButton,
    Tooltip,
    AllCheckUncheck,
    DateInput,
  },

  props: {
    refreshEvent: String,
    apiSearchExtraFilter: {},
    autoLoad: { type: Boolean, default: true },
    altBackground: { type: Boolean, default: false },
    openDetails: { type: Boolean, default: false },
    searchTextOnEnter: { type: Boolean, default: false },
    autoHideFilterSortButtons: { type: Boolean, default: false },

    title: String,

    hideOnEmpty: { type: Boolean, default: false },

    url: String,
    baseSizes: {
      type: Array as () => number[],
      default: () => [10, 20, 50, 100],
    },
    delay: { type: Number, default: 0 },

    openDetailsByDefault: { type: Boolean, default: false },

    create: String,
    resetFilter: { type: Boolean, default: true },
    resetSort: { type: Boolean, default: true },
    search: { type: Boolean, default: true },
    searchPlaceholder: { type: String, default: "Keresés" },
    searchTooltip: { type: String, default: "" },
    showFilter: { type: Boolean, default: false },
    multiView: { type: Boolean, default: false },
    refresh: { type: Boolean, default: true },
    showDivider: { type: Boolean, default: true },
    showExtraDateFilter: { type: Boolean, default: false },
    tableColPadding: { type: Number, default: 16 },

    filterFieldAutoGrow: { type: Boolean, default: true },
    detailsRaw: { type: Boolean, default: false },
    detailsCloseButton: { type: Boolean, default: false },
    overlayProgressIcon: { type: Boolean, default: false },
    groupColumn: { type: String, default: null },
    infiniteScroll: { type: Boolean, default: false },
    persistFilters: { type: Boolean, default: false },
    kendoGrid: { type: Boolean, default: false },
    layoutKey: { type: String, default: "" },

    columns: {
      type: Array as () => ApiSearchColumn[],
      default: () => new Array<ApiSearchColumn>(),
    },

    filterable: { type: Boolean, default: true },
    multiselect: { type: Boolean, default: false },
    sortable: { type: Boolean, default: true },
    fixedTable: { type: Boolean, default: false },
    extraFilter: { type: Object as () => FilteringModel, default: undefined },
    maxColWidth: { type: Number, default: 200 },
    detailsField: { type: String, default: "details" },
    displayTitles: { type: Boolean, default: false },
    hasPager: { type: Boolean, default: true },
    name: { type: String, default: "api-search-page" },
    exclusiveItems: {
      type: Array as () => number[],
      default: () => {
        return [];
      },
    },
    selectedRowColor: { type: String, default: "" },
    selectedField: { type: String, default: "selected" },
    color: { type: String, default: "" },
  },

  data: (): Data => ({
    api: new ServerSideSearchApi(),
    apiSearch: new ApiSearch(),
    items: [],
    totalItems: 0,
    localColumns: [],
    isTableView: true,
    isFilterVisible: false,
    loading: false,
    loadingMore: false,
    eventListenersAdded: false,
    hasFiltering: false,
    hasSorting: false,
    multiSelectSelectedOptions: {},
  }),

  async beforeMount() {
    /** Create new ApiSearchColumn from params */
    this.localColumns = this.$props.columns.map((c: unknown) => new ApiSearchColumn(c as Partial<ApiSearchColumn>));

    // TODO: default filter support
    let filter = this.$props.filterable
      ? new FilteringModel().values(
          this.localColumns
            .filter((x) => x.filterable && !x.multiselect && x.visible)
            .map((x) => ({ field: x.field ?? "" }))
            .filter((x) => !!x.field)
        )
      : undefined;

    const extraFilterCols = this.localColumns.filter((x) => x.extraFilterValue && x.visible);
    extraFilterCols.forEach((e) => {
      if (filter) {
        filter = filter.value(e.field ?? "", e.extraFilterValue ?? "");
      }
    });

    this.localColumns
      .filter((x) => x.multiselect && x.visible)
      .forEach((e) => {
        if (filter) {
          filter = filter.multiSelect(
            e.multiselectField ?? "",
            e.multiselectOptions ?? [],
            typeof e.multiselectSelect === "number" && e.multiselectSelect > 1
              ? [e.multiselectSelect]
              : (e.multiselectSelect?.constructor === Array ? e.multiselectSelect : e.multiselectOptions?.map((x) => x.value)) 
          );

          // $set: a kulcs reaktív legyen, különben a Kendo szűrőcella "Összes" felirata nem frissül.
          this.$set(this.multiSelectSelectedOptions, e.multiselectField ?? "", typeof e.multiselectSelect === "number" && e.multiselectSelect > 1
              ? [e.multiselectSelect]
              : (e.multiselectSelect?.constructor === Array ? e.multiselectSelect : e.multiselectOptions?.map((x) => x.value)));
        }
      });

    this.localColumns
      .filter((x) => x.range && x.visible)
      .forEach((e) => {
        if (filter) {
          filter = filter.range(e.field ?? "");
        }
        // console.log(e);
      });

    // TODO: default filter support
    const sort = this.sortable
      ? new SortingModel().capitalize().fields(
          this.localColumns
            .filter((x) => x.sortable && x.visible)
            .map((x) => ({ field: x.field ?? "", text: x.title ?? "" }))
            .filter((x) => !!x.field && !!x.text)
        )
      : undefined;

    const old = this.apiSearch;
    /** Init ApiSearch */
    this.apiSearch = new ApiSearch({
      pageSize: this.$props.hasPager ? this.$props.baseSizes[0] : 1000,
      filter: filter,
      extraFilter: old?.extraFilter ?? this.apiSearchExtraFilter,
      sort: sort,
      searchText: "",
    });

    // Navigáció utáni visszatérésnél a korábban elmentett szűrő-állapot
    // visszatöltése — így az autoLoad már a visszaállított szűrőkkel kérdez le.
    if (this.persistFilters) {
      const saved = getApiSearchState(this.persistKey);
      if (saved) {
        this.applyApiSearchValues(saved.apiSearch);
        this.multiSelectSelectedOptions = { ...saved.multiSelectSelectedOptions };
      }
    }

    /** Load first page, then apply debounce() */
    if (this.$props.url != "" && this.autoLoad) {
      await this.changeHandler(); // api call to the backend
    }

    this.changeHandler = debounce(this.changeHandler, this.$props.delay);

    eventBus.$on(`${this.$props.name}:set-items`, (items) => {
      this.items = items;
    });

    eventBus.$on(`${this.$props.name}:add-item`, (item) => {
      if(!this.items.some((p: any) => p.id === 0))
      {
        this.items.unshift(item);
      }
    });

    eventBus.$on(`${this.$props.name}:remove-item`, (item) => {
      this.items = this.items.filter((i: any) => i.id !== item.id);
    });

    eventBus.$on(`${this.$props.name}:reload`, () => {
      this.changeHandler();
    });

    if (this.refreshEvent)
      eventBus.$on(this.refreshEvent, () => {
        this.changeHandler();
      });

    eventBus.$on(`${this.$props.name}:close-details`, () => {
      this.items.forEach((item: unknown) => {
        Object.defineProperty(item, this.$props.detailsField, {
          value: false,
          writable: true,
          enumerable: true,
          configurable: true,
        });
      });
    });
  },

  watch: {
    columns() {
      /** Create new ApiSearchColumn from params */
      this.localColumns = this.$props.columns.map((c: unknown) => new ApiSearchColumn(c as Partial<ApiSearchColumn>));

      // TODO: default filter support
      let filter = this.$props.filterable
        ? new FilteringModel().values(
            this.localColumns
              .filter((x) => x.filterable && !x.multiselect && x.visible)
              .map((x) => ({ field: x.field ?? "" }))
              .filter((x) => !!x.field)
          )
        : undefined;

      const extraFilterCols = this.localColumns.filter((x) => x.extraFilterValue && x.visible);
      extraFilterCols.forEach((e) => {
        if (filter) {
          filter = filter.value(e.field ?? "", e.extraFilterValue ?? "");
        }
      });

      this.localColumns
        .filter((x) => x.multiselect && x.visible)
        .forEach((e) => {
          if (filter) {
            filter = filter.multiSelect(
              e.multiselectField ?? "",
              e.multiselectOptions ?? [],
              e.multiselectOptions?.map((x) => x.value)
            );
          }
        });

      this.localColumns
        .filter((x) => x.range && x.visible)
        .forEach((e) => {
          if (filter) {
            filter = filter.range(e.field ?? "");
          }
        });

      // TODO: default filter support
      const sort = this.sortable
        ? new SortingModel().capitalize().fields(
            this.localColumns
              .filter((x) => x.sortable && x.visible)
              .map((x) => ({ field: x.field ?? "", text: x.title ?? "" }))
              .filter((x) => !!x.field && !!x.text)
          )
        : undefined;

      const old = this.apiSearch;
      /** Init ApiSearch */
      this.apiSearch = new ApiSearch({
        pageSize: this.$props.hasPager ? this.$props.baseSizes[0] : 1000,
        filter: filter,
        extraFilter: old?.extraFilter ?? this.apiSearchExtraFilter,
        sort: sort,
        searchText: "",
        stopFilterLoad: true,
        stopSortLoad: true,
      });

      // Oszlop-újraépítéskor (pl. a multiselect options csak később, aszinkron
      // töltődnek be) a felhasználó élő szűrő-értékeit átmentjük az új szerkezetbe.
      this.applyApiSearchValues(old);

      // A visszatöltés a filter/sort watchereken egy felesleges újratöltést indítana, ezt fogják
      // meg a stop flagek. Ha viszont nem változott érték (nem futott watcher), a flagek bent
      // maradnának, és a felhasználó KÖVETKEZŐ szűrését vagy rendezését nyelnék el — ezért a
      // watcher-sor kiürülése után eldobjuk őket.
      this.$nextTick(() => {
        this.apiSearch.stopFilterLoad = false;
        this.apiSearch.stopSortLoad = false;
      });
    },
    exclusiveItems() {
      this.changeHandler();
    },
    /** Load items on Filter change */
    "apiSearch.searchText": {
      deep: true,
      handler(_: FilteringModel | undefined, old: FilteringModel | undefined) {
        // block refresh while it's undefined
        if (!old) return;
        if (!this.autoLoad) return;
        if (this.searchTextOnEnter) return;
        this.changeHandler();
      },
    },

    /** Külső (pl. toolbar) szűrő-változások figyelése: frissítjük az apiSearch.extraFilter-t és újratöltünk */
    apiSearchExtraFilter: {
      deep: true,
      handler(newVal) {
        if (!this.apiSearch) return;
        this.apiSearch.extraFilter = newVal;
        if (!this.autoLoad) return;
        this.changeHandler();
      },
    },

    /** Load items on Filter change */
    "apiSearch.filter": {
      deep: true,
      handler(_: FilteringModel | undefined, old: FilteringModel | undefined) {
        // block refresh while it's undefined
        if (!old) return;
        if (this.apiSearch.stopFilterLoad) {
          this.apiSearch.stopFilterLoad = false;
          return;
        }
        this.changeHandler();
      },
    },
    
    /** Load items Sort change */
    "apiSearch.sort": {
      deep: true,
      handler(_: SortingModel | undefined, old: SortingModel | undefined) {
        // block refresh while it's undefined
        if (!old) return;
        if (this.apiSearch.stopSortLoad) {
          this.apiSearch.stopSortLoad = false;
          return;
        }
        this.changeHandler();
      },
    },
  },

  created() {
    // A handlereket eltároljuk, hogy beforeDestroy-ban célzottan tudjuk őket
    // leiratkoztatni. A globális eventBus singleton: cleanup nélkül minden
    // mount újabb listenert hagyna hátra (memóriaszivárgás + szellem-listenerek).
    const handlers = {
      getItems: () => {
        this.$emit("items", this.items);
      },
      setItems: (items: any) => {
        this.items = items;
      },
      addItem: (item: any) => {
        if(!this.items.some((props: any) => props.id === 0))
        {
          this.items.unshift(item);
        }
      },
      removeItem: (item: any) => {
        this.items = this.items.filter((i: any) => i.id !== item.id);
      },
      reload: () => {
        this.changeHandler();
      },
      closeDetails: () => {
        this.items.forEach((item: unknown) => {
          Object.defineProperty(item, this.$props.detailsField, {
            value: false,
            writable: true,
            enumerable: true,
            configurable: true
          });
        });
      },
    };
    (this as any)._busHandlers = handlers;

    eventBus.$on(`${this.$props.name}:get-items`, handlers.getItems);
    eventBus.$on(`${this.$props.name}:set-items`, handlers.setItems);
    eventBus.$on(`${this.$props.name}:add-item`, handlers.addItem);
    eventBus.$on(`${this.$props.name}:remove-item`, handlers.removeItem);
    eventBus.$on(`${this.$props.name}:reload`, handlers.reload);
    eventBus.$on(`${this.$props.name}:close-details`, handlers.closeDetails);
  },

  mounted() {
    this.$nextTick(() => this.attachInfiniteScroll());
  },

  updated() {
    // A gyökérelem v-if-je miatt a sentinel később is létrejöhet / újra-
    // cserélődhet; ilyenkor újra rá kell kötni a megfigyelőt.
    this.attachInfiniteScroll();
  },

  beforeDestroy() {
    // A szűrő-állapot elmentése, hogy a következő mount (navigáció után)
    // vissza tudja tölteni.
    if (this.persistFilters) {
      saveApiSearchState(this.persistKey, {
        apiSearch: this.apiSearch,
        multiSelectSelectedOptions: this.multiSelectSelectedOptions,
      });
    }

    const observer = (this as any)._infiniteObserver as IntersectionObserver | undefined;
    if (observer) {
      observer.disconnect();
      (this as any)._infiniteObserver = undefined;
      (this as any)._observedSentinel = undefined;
    }

    const handlers = (this as any)._busHandlers;
    if (!handlers) return;
    // Csak a saját handlereinket iratkoztatjuk le (nem handler nélküli $off-ot
    // hívunk), így nem töröljük egy másik, azonos nevű, még élő instance
    // listenereit.
    eventBus.$off(`${this.$props.name}:get-items`, handlers.getItems);
    eventBus.$off(`${this.$props.name}:set-items`, handlers.setItems);
    eventBus.$off(`${this.$props.name}:add-item`, handlers.addItem);
    eventBus.$off(`${this.$props.name}:remove-item`, handlers.removeItem);
    eventBus.$off(`${this.$props.name}:reload`, handlers.reload);
    eventBus.$off(`${this.$props.name}:close-details`, handlers.closeDetails);
  },

  methods: {
    /**
     * Egy korábbi ApiSearch értékeinek mezőnkénti átvétele az aktuális
     * `apiSearch`-be. Szándékosan értékenként másolunk (nem objektum-cserével):
     * így a frissen épített szerkezet (pl. később betöltődő multiselect
     * options) és az initFilter/initSort (a "Szűrés eltávolítása" alapállapota)
     * érintetlen marad, és csak a közös mezők értékei kerülnek át. Újratöltést
     * nem indít: beforeMount-ban a filter watcher `old` nélkül blokkol, az
     * oszlop-watcherben pedig a stopFilterLoad/stopSortLoad flagek nyelik el.
     */
    applyApiSearchValues(source) {
      if (!source) return;

      this.apiSearch.searchText = source.searchText ?? "";
      // Lapozás átvétele — nincs rá watcher, újratöltést nem indít; a pager
      // az initialPage/initialPageSize propokon keresztül áll rá.
      this.apiSearch.currentPage = source.currentPage ?? 1;
      this.apiSearch.pageSize = source.pageSize ?? this.apiSearch.pageSize;

      const target = this.apiSearch.filter;
      const savedFilter = source.filter;
      if (target && savedFilter) {
        Object.keys(target.filters).forEach((key) => {
          const from = savedFilter.filters[key] as any;
          const to = target.filters[key] as any;
          if (!from) return;
          if ("value" in to && "value" in from) {
            to.value = from.value;
          } else if ("min" in to && "min" in from) {
            to.min = from.min;
            to.max = from.max;
          } else if ("selectedOptions" in to && "selectedOptions" in from) {
            to.selectedOptions = [...(from.selectedOptions ?? [])];
          }
        });
      }

      const savedSort = source.sort;
      if (this.apiSearch.sort && savedSort) {
        this.apiSearch.sort.definitions.forEach((d) => {
          const from = savedSort.definitions.find((x) => x.field === d.field);
          if (from) {
            d.order = from.order;
          }
        });
      }
    },

    multiSelectSelectionChanged(){
      Object.keys(this.multiSelectSelectedOptions).forEach(key => {
          if (this.apiSearch.filter){
            (this.apiSearch.filter.filters[key] as any).selectedOptions = this.multiSelectSelectedOptions[key];
          }
        });
    },

    addFilterWIdthEventListeners(){
      if (this.filterFieldAutoGrow && !this.eventListenersAdded){

      this.eventListenersAdded = true;
      const inputs = document.querySelectorAll('.filter-field input');

      inputs.forEach(i => {
        let defaultWidth = 0; 
        const element = (i as any);

        const dummySpan = document.createElement('span');
        dummySpan.style.position = 'absolute';
        dummySpan.style.left = '-99999999px';
        dummySpan.style.fontSize = '12px';
        dummySpan.classList.add('maxWidth');
        element.parentNode.appendChild(dummySpan);

        i.addEventListener('input', () => {
          if (defaultWidth == 0){
            defaultWidth = i.clientWidth;
          }

          dummySpan.innerHTML = element.value.replace(/\s/g, '&nbsp;');
          const newWidth = dummySpan.offsetWidth;

          if (newWidth > defaultWidth){
            element.style.width = newWidth + 'px';
          }
        });
      });
    }
    },

    showItem(item: any) {
      if (this.$props.exclusiveItems.length < 0 || (item?.id ?? false)) {
        return true;
      } else {
        if (this.$props.exclusiveItems.includes(Number(item.id))) {
          return false;
        } else return true;
      }
    },

    refreshClick(): void {
      eventBus.$emit("api-pager:set-page", 1);
      this.changeHandler();
    },

    resetFilterClick(): void {
      this.apiSearch.resetFiltering();
      this.$emit("reset-filtering");
    },

    resetSortClick(): void {
      this.apiSearch.resetSorting();
      this.$emit("reset-sorting");
    },

    async changeHandler(): Promise<void> {
      this.$emit("before-refresh");
      //! Can be cancelled
      const apiSearch = eventBus.$emit("refreshing", this.apiSearch);
      console.log("refreshing");
      this.loading = true;

      // Végtelen görgetésnél minden teljes újratöltés (szűrés, keresés,
      // rendezés, frissítés) az első oldaltól indul.
      if (this.$props.infiniteScroll) {
        this.apiSearch.currentPage = 1;
      }

      this.hasFiltering = false;
      if (this.apiSearch.filter){
        if (this.apiSearch.searchText){
          this.hasFiltering = true;
        }

        for (const [key, value] of Object.entries(this.apiSearch.filter?.filters)) {
          if(value.hasValue()){
            this.hasFiltering = true;
          }
        }
      }

      this.hasSorting = false;
      if (this.apiSearch.sort){
        this.hasSorting = this.apiSearch.sort.definitions.filter(x => x.order != "None").length > 0;
      }

      try {
        const result = await this.api.post(this.$props.url, this.apiSearch);
        // console.log(result);
        if (result) {
          this.totalItems = result.totalCount;
          this.items = this.hasDetails
            ? result.currentPage.map((i) => {
                // Add custom detailsField prop
                Object.defineProperty(i, this.$props.detailsField, {
                  value: this.$props.openDetailsByDefault,
                  writable: true,
                  enumerable: true,
                  configurable: true,
                });

                return i;
              })
            : result.currentPage;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      } finally {
        console.log(this.apiSearch);
        this.loading = false;
      }

      this.$emit("itemCount", this.items?.length ?? 0);
      this.$emit("items", this.items);
      eventBus.$emit("refreshed", this.apiSearch);

      this.addFilterWIdthEventListeners();

      // Teljes újratöltés (pl. szűrés törlése) után is újra ki kell értékelni
      // a sentinel láthatóságát: ha minden elem kifér a képernyőre, e nélkül
      // nem töltődne be a következő oldal.
      if (this.$props.infiniteScroll) {
        this.reobserveInfiniteScroll();
      }
    },

    attachInfiniteScroll(): void {
      if (!this.$props.infiniteScroll) return;

      const sentinel = this.$refs.infiniteScrollSentinel as Element | undefined;
      if (!sentinel) return;

      const existing = (this as any)._infiniteObserver as IntersectionObserver | undefined;
      if (existing && (this as any)._observedSentinel === sentinel) return;
      if (existing) existing.disconnect();

      // A görgető konténer (max-height) a root, hogy a táblázaton belüli
      // scroll váltsa ki a következő oldal betöltését. Fallback: viewport.
      const container = this.$refs.tableContainer as any;
      const root: Element | null = container?.$el ?? container ?? null;

      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            this.loadNextPage();
          }
        },
        { root }
      );
      observer.observe(sentinel);

      (this as any)._infiniteObserver = observer;
      (this as any)._observedSentinel = sentinel;
    },

    async loadNextPage(): Promise<void> {
      if (this.loading || this.loadingMore) return;
      if (this.items.length >= this.totalItems) return;

      this.loadingMore = true;
      this.apiSearch.currentPage++;

      try {
        const result = await this.api.post(this.$props.url, this.apiSearch);
        if (result) {
          this.totalItems = result.totalCount;
          const newItems = this.hasDetails
            ? result.currentPage.map((i) => {
                // Add custom detailsField prop
                Object.defineProperty(i, this.$props.detailsField, {
                  value: this.$props.openDetailsByDefault,
                  writable: true,
                  enumerable: true,
                  configurable: true,
                });

                return i;
              })
            : result.currentPage;

          this.items = this.items.concat(newItems);
        }
      } catch (error) {
        console.log(error);
        // Sikertelen betöltésnél visszalépünk, hogy a következő görgetés
        // újra ugyanezt az oldalt próbálja.
        this.apiSearch.currentPage--;
      } finally {
        this.loadingMore = false;
      }

      this.$emit("itemCount", this.items?.length ?? 0);
      this.$emit("items", this.items);

      this.reobserveInfiniteScroll();
    },

    reobserveInfiniteScroll(): void {
      // Ha a sentinel a betöltés után is látható maradt (a lista rövidebb a
      // képernyőnél), az IntersectionObserver magától nem tüzel újra —
      // újra-megfigyeléssel friss kiértékelést kényszerítünk ki.
      this.$nextTick(() => {
        const observer = (this as any)._infiniteObserver as IntersectionObserver | undefined;
        const sentinel = this.$refs.infiniteScrollSentinel as Element | undefined;
        if (observer && sentinel) {
          observer.unobserve(sentinel);
          observer.observe(sentinel);
        }
      });
    },

    pagerChanged(pager: PaginatedPager): void {
      if (
        // block double API calls from: search change -> pager update
        pager.totalItems === 0 ||
        (this.apiSearch.currentPage === pager.currentPage && this.apiSearch.pageSize === pager.pageSize)
      )
        return;

      this.apiSearch.currentPage = pager.currentPage;
      this.apiSearch.pageSize = pager.pageSize;
      this.changeHandler();
    },

    getFieldOrder(field: string): SortOrder {
      return this.apiSearch.sort?.definitions.find((x) => x.field === field)?.order ?? SortOrder.None;
    },

    toggleSort(field: string): void {
      this.apiSearch.sort?.toggle(field);
    },

    getHeaderClasses,
    getFieldClasses,
    getAltRow,

    getRowStyle(item: any): object {
      if (this.$props.selectedRowColor && item && item[this.$props.selectedField]) {
        return { backgroundColor: this.$props.selectedRowColor };
      }
      return {};
    },

    closeItemDetails(item, event?: Event): void {
      // A details sor előtti tr maga a fő sor — becsukás után erre görgetünk vissza.
      const row = event?.currentTarget instanceof HTMLElement
        ? (event.currentTarget.closest("tr")?.previousElementSibling as HTMLElement | null)
        : null;

      item[this.$props.detailsField] = false;
      this.$emit("details-closed", item);

      if (!row) return;

      // A sticky fejléc (Page sticky-header slot) kitakarná a sort, ezért az
      // aktuális aljához igazítunk; a magassága oldalanként eltér, ezért mérjük.
      const sticky = document.querySelector(".sticky-header-slot");
      row.style.setProperty("scroll-margin-top", `${sticky ? sticky.getBoundingClientRect().bottom : 0}px`);

      // nextTick: a görgetés már az összecsukott elrendezéshez képest történjen.
      this.$nextTick(() => row.scrollIntoView({ behavior: "smooth", block: "start" }));
    },

    toggleExtraFilterVisibility() {
      this.isFilterVisible = !this.isFilterVisible;
      this.$emit("efilter-toggle", this.isFilterVisible);
    },
  },

  computed: {
    /** A perzisztált szűrő-állapot kulcsa — a name önmagában nem egyedi (default + típusonként más oszlopok). */
    persistKey(): string {
      return `${this.$props.name}|${this.$props.url}`;
    },

    effectiveColor(): string {
      return this.$props.color || "primary";
    },

    effectiveColorCss(): string {
      return this.$props.color || "var(--primaryColor)";
    },

    /** A layout-key önmagában is Kendo gridet jelent: az elrendezés-profilokhoz átrendezhető oszlopok kellenek. */
    useKendoGrid(): boolean {
      return this.kendoGrid || !!this.layoutKey;
    },

    rootCssVars(): object {
      if (!this.$props.color) return {};
      return {
        "--primaryColor": this.$props.color,
        "--primaryColorHover": this.$props.color,
      };
    },

    hasGrouping(): boolean {
      return this.$props.groupColumn != null && this.$props.groupColumn != '';
    },

    grouppedRows(): any[] {
      const ret: any[] = [];

      const groupped = groupBy(this.items, this.$props.groupColumn);
      for (const group in groupped) {
        ret.push(Vue.observable({expanded: true, group: group, items: groupped[group]}))
      }

      console.log(ret);

      return ret;
    },

    hasNoItems(): boolean {
      return (this.items?.length ?? 0) < 1;
    },

    hasCustomTable(): boolean {
      return !!this.$scopedSlots.customTable || !!this.$slots.customTable;
    },

    hasCustomTableBody(): boolean {
      return !!this.$scopedSlots.customTableBody || !!this.$slots.customTableBody;
    },

    hasDetails(): boolean {
      return !!this.$scopedSlots.details || !!this.$slots.details;
    },

    hasListView(): boolean {
      return !!this.$scopedSlots.listView || !!this.$slots.listView;
    },

    hasFilters(): boolean {
      return !!this.$scopedSlots.filters || !!this.$slots.filters;
    },

    hasViews(): boolean {
      return !!this.$scopedSlots.views || !!this.$slots.views;
    },

    hasHeaders(): boolean {
      return !!this.$scopedSlots.headers || !!this.$slots.headers;
    },

    hasComponentNextToCreateButton(): boolean {
      return !!this.$scopedSlots.componentNextToCreateButton || !!this.$slots.componentNextToCreateButton;
    },

    hasBottom(): boolean {
      return !!this.$scopedSlots.bottom || !!this.$slots.bottom;
    },
  },
});
